<template>
  <a :href="href" class="w-button" v-if="href">
    <slot></slot>
  </a>
  <button class="w-button" @click="handleClick" v-else>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name : `wButton`,
  props : {
    href : {
      type    : null,
      default : () => null,
    },
  },
  methods : {
    handleClick () {
      if (this.href) {
        window.location.href = this.href;
      }
    },
  },
};
</script>

<style lang="scss">
  @import '~styles/button.scss';
</style>



// WEBPACK FOOTER //
// WButton.vue?9d5e3152